import { Localized, useLocalization } from '@fluent/react';
import { Textarea } from '@vechaiui/react';
import { useField } from 'formik';

import ContactPointForm from '#/components/forms/ContactPointForm';
import Fieldset from '#/components/forms/Fieldset';
import PostalAddressForm from '#/components/forms/PostalAddressForm';
import { ContainerPacking } from '#/__generated__/graphql/graphql';
import { ContainerPackingSwitchFormik } from '#/components/controls/ContainerPackingSwitch';
import { IndustryListboxFormik } from '#/components/controls/IndustryListbox';
import { InputFormik } from '#/components/controls/Input';
import { MalaysiaStateCheckboxGroupFormik } from '#/components/controls/MalaysiaStateCheckboxGroup';

const CustomerSignupForm = () => {
  const { l10n } = useLocalization();
  const [businessCategoryIdField] = useField('businessCategoryId');

  return (
    <div className="divide-y">
      <div className="space-y-6 pb-8">
        <Localized id="organization-name" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('organization-name')} name="name" />
        </Localized>

        <Localized id="company-number" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('company-number')} name="companyNumber" />
        </Localized>

        <Localized id="organization-telephone" attrs={{ placeholder: true }}>
          <InputFormik
            inputMode="tel"
            label={l10n.getString('organization-telephone')}
            name="telephone"
          />
        </Localized>

        <PostalAddressForm name="address" />

        <div className="space-y-2">
          <IndustryListboxFormik
            additionalItems={[{ id: 'other', name: l10n.getString('other') }]}
            label={l10n.getString('business-category')}
            name="businessCategoryId"
          />

          {businessCategoryIdField.value === 'other' && (
            <Localized id="other-business-category" attrs={{ placeholder: true }}>
              <InputFormik
                label={l10n.getString('other-business-category')}
                name="otherBusinessCategory"
              />
            </Localized>
          )}
        </div>

        <Localized id="cargo-details" attrs={{ placeholder: true }}>
          <InputFormik as={Textarea} label={l10n.getString('cargo-details')} name="cargoDetails" />
        </Localized>

        <Fieldset title={l10n.getString('preferred-container-packing')}>
          <ContainerPackingSwitchFormik
            name="preferredContainerPacking"
            rightText={l10n.getString(ContainerPacking.LessThanContainerLoad)}
          />
        </Fieldset>

        <Fieldset title={l10n.getString('areas-served')}>
          <MalaysiaStateCheckboxGroupFormik name="areasServed" />
        </Fieldset>

        <Fieldset title={`${l10n.getString('primary')} ${l10n.getString('person-in-charge')}`}>
          <ContactPointForm name="contactPoints.0" showLabel={false} />
        </Fieldset>

        <Fieldset title={`${l10n.getString('secondary')} ${l10n.getString('person-in-charge')}`}>
          <ContactPointForm name="contactPoints.1" showLabel={false} />
        </Fieldset>
      </div>

      <div className="space-y-6 pt-6">
        <Localized id="referral" attrs={{ placeholder: true }}>
          <InputFormik label={l10n.getString('referral')} name="referral" />
        </Localized>

        <Localized id="remark" attrs={{ placeholder: true }}>
          <InputFormik as={Textarea} label={l10n.getString('remark')} name="remark" />
        </Localized>
      </div>
    </div>
  );
};

export default CustomerSignupForm;
